import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST, VUE_APP_ACCESS_TOKEN } from '../../config/app-const';

const state = {
  user: {
    isBusy: false,
    data: null,
    error: null
  },
  userCoder: {
    isBusy: false,
    data: null,
    error: null
  },
  preferences: {},
};

const getters = {
  fetchConfig(state) {
    const { accessToken } = state.user.data;
    return {
      headers: { Authorization: `Token token=${accessToken}` }
    };
  },
  permissions: (state) => {
    if (
      state.user &&
      state.user.data &&
      state.user.data.permissions
    ) return state.user.data.permissions;

    return null;
  },
  permissionAssignArticles: (state, getters) => {
    if (
      getters.permissions &&
      getters.permissions.assign_articles
    ) return getters.permissions.assign_articles;

    return 'no';
  }
}

const mutations = {
  LOAD_USER_BUSY: (state, payload) => {
    state.user.isBusy = payload;
  },
  LOAD_USER_SUCCESS: (state, payload) => {
    const storedData = JSON.parse(localStorage.getItem('projectcode-user'));

    const data = {
      ...storedData,
      ...payload,
      code_admin: payload.role.code_admin,
      code_editor: payload.role.code_editor,
      accessToken: `${payload.id}:${VUE_APP_ACCESS_TOKEN}`
    };

    state.user.data = data;
    state.user.error = null;
  },
  LOAD_USER_FAIL: (state, payload) => {
    state.user.data = null;
    state.user.error = payload;
  },
  // GET USER WITH CODER ADMIN AND CODER EDITOR TRUE
  LOAD_USER_CODER_BUSY: (state, payload) => {
    state.userCoder.isBusy = payload;
  },
  LOAD_USER_CODER_SUCCESS: (state, payload) => {
    state.userCoder.data = payload;
    state.userCoder.error = null;
  },
  LOAD_USER_CODER_FAIL: (state, payload) => {
    state.userCoder.data = null;
    state.userCoder.error = payload;
  },
  LOAD_USER_PREFERENCES_SUCCESS: (state, { name, settings }) => {
    state.preferences = { ...state.preferences, [name]: settings };
    state.user.error = null;
  },
}

const actions = {
  getUserInfo: ({ commit, rootState }) => {
    commit('LOAD_USER_BUSY', true);

    let accessToken = {}

    let projectCodeUser = JSON.parse(localStorage.getItem('projectcode-user'));
    let userId = projectCodeUser ? projectCodeUser.id : null;

    accessToken = {
      Authorization: `token Token=${userId}:${VUE_APP_ACCESS_TOKEN}`
    }

    if(rootState.insightSessionToken) {
      const insightToken = `Insight token=${rootState.insightSessionToken}`
      accessToken = {
        Authorization: insightToken
      }
    }

    const config = {
      headers: accessToken
    };

    const query = `?id=${userId}`;

    return Axios
      .get(`${API_HOST}/analysis/userinfo${query}`, config)
      .then(response => {
        commit('LOAD_USER_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });

        console.error(error);
        commit('LOAD_USER_FAIL', error)
      })
      .finally(() => commit('LOAD_USER_BUSY', false));
  },
  getUserCoder: ({ commit, rootState }, { projectId }) => {
    commit("LOAD_USER_CODER_BUSY", true);

    const { accessToken } = rootState.user.user.data;

    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };
    return Axios.get(`${API_HOST}/analysis/${projectId}/users`, config)
      .then(response => {
        commit("LOAD_USER_CODER_SUCCESS", response.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_USER_CODER_FAIL", error);
      })
      .finally(() => commit("LOAD_USER_CODER_BUSY", false));
  },
  updateUserPreferences: ({ commit, rootState }, { name, settings, projectId }) => {
    commit("LOAD_USER_BUSY", true);

    const url = `${API_HOST}/analysis/userinfo/table_settings`;
    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios.put(url, { name, settings, projectId }, config)
      .then(() => {
        commit("LOAD_USER_PREFERENCES_SUCCESS", { name, settings});
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_USER_FAIL", error);
      })
      .finally(() => commit("LOAD_USER_BUSY", false));
  },
  getUserPreferences: ({ commit, rootState }, { name, projectId }) => {
    commit("LOAD_USER_BUSY", true);

    let url = `/analysis/userinfo/table_settings?name=${name}`;
    if (projectId) {
      url += `&projectId=${projectId}`;
    }
    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };
    return Axios.get(url, config)
      .then(response => {
        commit("LOAD_USER_PREFERENCES_SUCCESS", {
          name: name,
          settings: response.data.data.settings
        });
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_USER_FAIL", error);
      })
      .finally(() => commit("LOAD_USER_BUSY", false));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};